import request from '@/utils/request'

// 查询轨道交通系统列表
export function listMetro(query) {
  return request({
    url: '/admin/metro/sys/list',
    method: 'get',
    params: query
  })
}

// 查询轨道交通系统详细
export function getMetro(metroId) {
  return request({
    url: '/admin/metro/sys/getInfo?metroId=' + metroId,
    method: 'get'
  })
}

// 新增轨道交通系统
export function addMetro(data) {
  return request({
    url: '/admin/metro/sys',
    method: 'post',
    data: data
  })
}

// 修改轨道交通系统
export function updateMetro(data) {
  return request({
    url: '/admin/metro/sys',
    method: 'put',
    data: data
  })
}

// 删除轨道交通系统
export function delMetro(metroId) {
  return request({
    url: '/admin/metro/sys/deleteMetro?metroId='+metroId,
    method: 'delete'
  })
}

// 查询轨道交通系统列表
export function metroSelect() {
  return request({
    url: '/admin/metro/sys/optionSelect',
    method: 'get'
  })
}
